module.exports = __webpack_public_path__ + "static/media/ico_upi_512.53eb92ac.png";